import { animate } from 'framer-motion'
import { getFocus, setFocus } from 'state/jotai'
import { _isometry } from 'state/store.isometry'

export const useSnapLogic = ({
  value,
  setFrame,
  tweens,
  setShow,
  setIndex,
  SNP,
  setFrameFocus,
  pids,
  allConfig,
  pin
}) => {

  // ✅ Early exit if required data missing
  if (!Array.isArray(tweens) || tweens.length === 0 || value == null) {
    console.warn('⚠️ useSnapLogic: Invalid tweens or value', { value, tweens });
    return;
  }

  // ✅ Find the tween section containing the current value
  const SECT = tweens.findIndex(tween => Array.isArray(tween) && tween.includes(value));

  if (SECT === -1) {
    console.warn('⚠️ useSnapLogic: Value not found in any tween', { value, tweens });
    return;
  }

  const TWEEN = tweens[SECT];
  if (!TWEEN || TWEEN.length === 0) {
    console.warn('⚠️ useSnapLogic: Invalid TWEEN at index', SECT);
    return;
  }

  // ✅ Compute midpoint and direction
  const CEN = TWEEN[Math.floor(TWEEN.length / 2)];
  const DIR = value >= CEN ? 'UP' : 'DOWN';

  // ✅ Compute target FRAME safely
  const FRAME = DIR === 'UP' ? TWEEN[TWEEN.length - 1] : TWEEN[0];

  if (FRAME === undefined || isNaN(FRAME)) {
    console.warn('⚠️ useSnapLogic: FRAME is undefined or NaN', { DIR, TWEEN, FRAME });
    return;
  }

  // ✅ Set UI indicators
  const frameIndex = SNP?.indexOf(FRAME);
  setIndex(frameIndex ?? 0);
  setShow(true);
  // ✅ Log for debugging

  // ✅ Animate safely
  if (pin === 0) {
    animate(value, FRAME, {
      duration: 0.5,
      onUpdate: v => {
        setFrameFocus(f => (
          pids.map((p, cnfIndex) => {
            const overviewPid = allConfig?.[0]?.[pids[0]]?.ANGLES;
            if (cnfIndex === 0) {
              return { [p]: +v.toFixed(0) };
            } else {
              return {
                [p]: overviewPid?.[frameIndex]?.[p]?.[p]
              };
            }
          })
        ));
      },
    });
  } else {
    animate(value, FRAME, {
      duration: 0.3,
      onUpdate: v => setFrame(+v.toFixed(0)),
    });
  }
  //   animate(value, FRAME, {
  //   duration: 0.3,
  //   onUpdate: v => setFrame(+v.toFixed(0)),
  // })
};
